import {combine, merge, sample} from 'effector';
import i18next from 'i18next';
import {toast} from 'react-toastify';

import {RestError, showRestError} from 'core/errors';
import {initFiltersTable, initSortingsTable} from 'core/hooks/grid2.0';
import {InnerFilters} from 'types';
import {StaffTableFilter} from 'types/profile';
import {mapSortings} from 'utils/grid-mappers';

import {
    boundUserWithParticipantFx,
    createUserFx,
    data$,
    defaultFilters,
    defaultSortings,
    editUserData$,
    fetchDataFx,
    filters$,
    filtersChanged,
    filtersReset,
    Gate,
    idsForRemoveBoundedConfirmation$,
    onChangeIdsForBoundConfirmation,
    onChangeUserIdForRemoveConfirmation,
    onSetEditUser,
    pageNumber$,
    pageSize$,
    removeUserFx,
    sortings$,
    sortingsChanged,
    sortingsReset,
    stateReset,
    tableStateChanged,
    updateUserFx,
    userIdForRemoveConfirmation$,
} from './index';

const mapStaffFilters = (filters: InnerFilters): StaffTableFilter[] =>
    Object.entries(filters)
        .filter(([, value]) => typeof value === 'string' && value.trim().length > 0)
        .map(([id, value]) => ({
            id,
            value: String(value).trim(),
        }));

data$.on(fetchDataFx.doneData, (_, data) => data).reset(Gate.close);
userIdForRemoveConfirmation$
    .on(onChangeUserIdForRemoveConfirmation, (_, payload) => payload)
    .reset(Gate.close);
idsForRemoveBoundedConfirmation$
    .on(onChangeIdsForBoundConfirmation, (_, payload) => payload)
    .reset(Gate.close);
editUserData$.on(onSetEditUser, (_, payload) => payload);
pageNumber$.reset(stateReset, Gate.close);
pageSize$.reset(stateReset, Gate.close);

initFiltersTable(filters$, filtersChanged, filtersReset, defaultFilters, stateReset);
initSortingsTable(sortings$, sortingsChanged, sortingsReset, defaultSortings, stateReset);

sample({
    clock: merge([Gate.open, tableStateChanged, removeUserFx.done]),
    source: combine({
        filters: filters$,
        pageNumber: pageNumber$,
        pageSize: pageSize$,
        sortings: sortings$,
    }),
    fn: ({filters, pageNumber, pageSize, sortings}) => ({
        paging: {
            pageNumber,
            pageSize,
        },
        filters: mapStaffFilters(filters),
        sortings: mapSortings(sortings),
    }),
    target: fetchDataFx,
});

createUserFx.doneData.watch(() => toast.success(i18next.t('pages.register.message.success')));
updateUserFx.doneData.watch(() => toast.success(i18next.t('pages.register.message.update')));
removeUserFx.doneData.watch(() => toast.success(i18next.t('pages.register.message.remove')));
// boundUserWithParticipantFx.doneData.watch(() =>
//     toast.success(i18next.t('pages.register.message.update')),
// );

[fetchDataFx, createUserFx, updateUserFx, removeUserFx, boundUserWithParticipantFx].forEach((fx) =>
    fx.failData.watch((err) => showRestError(err as RestError)),
);
